import Api from 'requestapijs';
import { HEADER, API_URL } from '../config';
import { DndMutationInput, DndMutationPayload } from '../../schema';
import { Inject } from '../helpers';
import { UserService } from './userService';

const mutation = `
mutation CreateDnd($input: DndMutationInput!) {
  createDnd(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
`;

export class DndService {
  static instance: DndService;

  @Inject userService: UserService;

  constructor() {
    if (DndService.instance) {
      return DndService.instance;
    } else {
      DndService.instance = this;
    }
  }

  add(data: DndMutationInput, onSuccess: (reponse) => void, onError: (response) => void) {
    Api.graphql<{ input: DndMutationInput }, DndMutationPayload>(
      API_URL,
      { input: { ...data, addedbyid: this.userService.user$.getValue().id } },
      mutation,
      HEADER,
      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
    );
  }
}
